import styled from 'styled-components'

// Note: horizontal padding matches `.rewards-table`'s own 15px (rewards--table.scss) so the
// title/CTA line up with the filters/table below it, inside the shared `.rewards-container` card.
export const EmbedHeader = styled.div({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '15px 15px 0',
})
